import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var reducePropsGetter = function reducePropsGetter() {
  var decorators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var grid = arguments.length > 1 ? arguments[1] : undefined;
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var extraParams = arguments.length > 1 ? arguments[1] : undefined;
    var nextProps = props;
    decorators.forEach(function (decorator) {
      nextProps = decorator(nextProps, grid, extraParams);
    });
    return nextProps;
  };
};
/* eslint-disable-next-line max-params */

function evaluateTransforms(transforms, value) {
  var extraParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var grid = arguments.length > 4 ? arguments[4] : undefined;
  var nextProps = props;
  transforms.forEach(function (transform) {
    nextProps = transform(value, extraParams, nextProps, grid);
  });
  return nextProps;
}
/* eslint-disable-next-line max-params */

function evaluateFormatters(formatters, value) {
  var extraParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var grid = arguments.length > 3 ? arguments[3] : undefined;
  return formatters.reduce(function (result, formatter) {
    return formatter(result, extraParams, grid);
  }, value);
}
function composeFormatters(formatters, instance) {
  var getItemValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (record) {
    return record.data.name;
  };
  // todo: make the formatters subscribe to the item props instead of getting the whole instance
  // todo: addd should formatter update to memoize specific ones
  return function (props) {
    return formatters.reduce(function (result, formatter) {
      return formatter(result, props, instance);
    }, getItemValue(props.record));
  };
}
var applyDecorators = function applyDecorators(subject) {
  var decorators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return decorators.reduce(function (nextSubject, decorator) {
    return decorator.apply(void 0, [nextSubject].concat(args));
  }, subject);
};
var decorateColumns = function decorateColumns(columns, decorators, grid) {
  var nextColumns = applyDecorators(columns, decorators.decorateColumns, grid);
  return nextColumns.map(function (column, index) {
    return applyDecorators(column, decorators.decorateColumn, grid, index);
  });
};
var mergeInstance = function mergeInstance(instance, instanceHook) {
  return _objectSpread(_objectSpread({}, instance), instanceHook(instance));
};
var registerStateHookToInstance = function registerStateHookToInstance(instance, stateHook) {
  var _stateHook = stateHook(instance),
      state = _stateHook.state,
      actions = _stateHook.actions;

  return _objectSpread(_objectSpread({}, instance), {}, {
    state: _objectSpread(_objectSpread({}, instance.state), state),
    actions: _objectSpread(_objectSpread({}, instance.actions), actions)
  });
};

var reduceHotKey = function reduceHotKey(instance, _ref) {
  var key = _ref.key,
      handler = _ref.handler,
      options = _ref.options,
      allowDocumentHandler = _ref.allowDocumentHandler;
  return _objectSpread(_objectSpread({}, instance), {}, {
    hotKeys: _objectSpread(_objectSpread({}, instance.hotKeys), {}, _defineProperty({}, key, {
      handler: handler,
      options: options,
      allowDocumentHandler: allowDocumentHandler
    }))
  });
};

var registerHotKeysHookToInstance = function registerHotKeysHookToInstance(instance, hotKeysHook) {
  var hotKeys = hotKeysHook(instance);

  if (Array.isArray(hotKeys)) {
    return hotKeys.reduce(reduceHotKey, instance);
  }

  return reduceHotKey(instance, hotKeys);
};

export { applyDecorators, composeFormatters, decorateColumns, evaluateFormatters, evaluateTransforms, mergeInstance, reducePropsGetter, registerHotKeysHookToInstance, registerStateHookToInstance };
//# sourceMappingURL=utils.js.map
